import React from 'react';
import { Route } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import OccupancyRateContainer from './OccupancyRate';

export const OccupancyRateModule = () => (
  <Route exact path={APP_ROUTES.OCCUPANCY_RATE_MODULE.PATH} component={OccupancyRateContainer} />
);
